import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import formatTime from '@sdk/utils/dateFormat/formatTime';
import useAuth from '@sdk/authentication/useAuth';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { Banner } from '@web/timeClock/ClockedInBanner/clockedInBanner.styles';

type Props = {
  clockedIn: Date;
};

const ClockedInBanner = ({ clockedIn }: Props) => {
  const { currentUser } = useAuth();

  return (
    <Banner>
      <Text14 bold themeColor={ThemeColorType.white}>
        {gettext('Clocked in at ')}
        {formatTime(clockedIn, currentUser.settings.usTimeFormat)}
      </Text14>
    </Banner>
  );
};

export default ClockedInBanner;
